// Build-time environment. Webpack's `mode` replaces the `process.env.NODE_ENV`
// token with a literal string ('production' or 'development') at bundle time.
const NODE_ENV = process.env.NODE_ENV

export const isProduction = () => NODE_ENV === 'production'

/**
 * Gate a list of environment options by build target.
 *
 * The Production ('prod') option must only ever be reachable from a production
 * build. In any non-production build it is stripped out entirely so it can
 * neither be selected in a dropdown nor used to connect to production.
 *
 * @param {Array<{label: string, value: string}>} options - all possible env options
 * @returns {Array<{label: string, value: string}>} options allowed for this build
 */
export const gateEnvOptions = (options = []) =>
  isProduction()
    ? options.filter((option) => option.value === 'prod')
    : options.filter((option) => option.value !== 'prod')

/**
 * Pick a sensible default env from a gated option list: prefer Development when
 * available (non-prod builds), otherwise fall back to the first allowed option
 * (which is Production in a production build).
 *
 * @param {Array<{label: string, value: string}>} options - gated env options
 * @returns {{label: string, value: string} | undefined}
 */
export const getDefaultEnv = (options = []) =>
  options.find((option) => option.value === 'dev') || options[0]
